/* Buy 2 tees, get a badge free: nudge after cart changes and on page load. */
(function () {
  if (!window.fetch) return;
  var TEES = ['T-shirts', 'Baby Tee'], BADGE = 'Badges';
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var onCart = document.body.classList.contains('template-cart');
  var nativeFetch = window.fetch;
  var msgs = {
    one: { t: 'Ek tee done. Do tee, badge free.', s: 'Add one more tee and pick any badge on us.', cta: 'Shop tees', url: base + 'collections/all-tees' },
    unlock: { t: 'Ek tee, do tee, badge free', s: 'You unlocked it. Pick any badge and it comes off at checkout.', cta: 'Pick my badge', url: base + 'collections/feminitee-badges' },
    done: { t: 'Ek, do, badge free. Done.', s: 'One badge is on us with your 2 tees.', cta: '', url: '' }
  };
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function stateOf(cart) {
    var tees = 0, badges = 0;
    (cart.items || []).forEach(function (i) {
      if (TEES.indexOf(i.product_type) > -1) tees += i.quantity;
      else if (i.product_type === BADGE) badges += i.quantity;
    });
    if (tees === 1) return 'one';
    if (tees >= 2 && badges === 0) return 'unlock';
    if (tees >= 2 && badges > 0) return 'done';
    return null;
  }
  var box, timer;
  function show(state) {
    var m = msgs[state]; if (!m) return;
    if (!box) {
      box = document.createElement('div');
      box.className = 'bo-nudge'; box.setAttribute('role', 'status'); box.setAttribute('aria-live', 'polite'); box.hidden = true;
      document.body.appendChild(box);
      box.addEventListener('click', function (e) {
        if (e.target.closest('.bo-nudge__close')) { store('bo-x-' + box.dataset.state, '1'); hide(); }
      });
    }
    box.dataset.state = state;
    box.innerHTML = '<span class="bo-strip__icon" aria-hidden="true"><svg viewBox="0 0 48 48" width="40" height="40"><circle cx="24" cy="24" r="20" fill="#D4FF3A" stroke="#141414" stroke-width="2.5"/><circle cx="24" cy="24" r="14.5" fill="none" stroke="#141414" stroke-width="1.5" stroke-dasharray="3 3.5"/><text x="24" y="29" text-anchor="middle" font-family="Arial Black, Arial, sans-serif" font-weight="900" font-size="11" fill="#141414">FREE</text></svg></span>' +
      '<span><strong>' + m.t + '</strong>' + m.s + (m.cta ? '<br><a class="bo-nudge__cta" href="' + m.url + '">' + m.cta + '</a>' : '') + '</span>' +
      '<button type="button" class="bo-nudge__close" aria-label="Close">&times;</button>';
    box.hidden = false; void box.offsetWidth; box.classList.add('is-in');
    clearTimeout(timer);
    if (state === 'done') timer = setTimeout(hide, 5000);
  }
  function hide() { if (!box) return; box.classList.remove('is-in'); setTimeout(function () { box.hidden = true; }, 300); }
  function check(fromChange) {
    if (onCart) return;
    if (fromChange && window.EkdDrawer) return;
    nativeFetch.call(window, base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var s = stateOf(cart);
        if (!s) { hide(); return; }
        var last = store('bo-last');
        store('bo-last', s);
        if (fromChange) {
          if (s === 'done' && last === 'done') return;
          show(s);
        } else if (s !== 'done' && !store('bo-x-' + s)) {
          show(s);
        }
      }).catch(function () {});
  }
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (r) { if (r.ok) setTimeout(function () { check(true); }, 250); }).catch(function () {});
    }
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { check(false); }); else check(false);
})();
